import { BlockchainNetwork } from "../constants.js"

type BlockchainPrefixes = { [K in BlockchainNetwork]?: string }
export const blockchainPrefixes: BlockchainPrefixes = {
    [BlockchainNetwork.ethereum]: '0x'
}

export const addBlockchainPrefix =
    (address: string, blockchain: BlockchainNetwork) =>
        (address === '' ?
            '0x0000000000000000000000000000000000000000' :
            `${blockchainPrefixes[blockchain] ?? ''}${address}`)

export const removeBlockchainPrefix =
    (address: string, blockchain: BlockchainNetwork) => {
        if (!address) return address
        if (blockchain in blockchainPrefixes && address.startsWith(blockchainPrefixes[blockchain]!)) {
            return address.replace(blockchainPrefixes[blockchain]!, '').toLowerCase()
        }

        return address
    }

export const formatBlockchainAddress =
    (address: string) => `${address.slice(0, 4)}...${address.slice(-4)}`
